<div class="app-container">
  <!-- <ngx-loading-bar [includeBar]="includeLoadingBar" [includeSpinner]="false" [height]="'4px'" [ref]="barRef"
    [color]="'#52c8ff'"></ngx-loading-bar> -->

  <!-- Main router outlet -->
  <div class="content-container">
    <div class="outlet-container">
      <router-outlet id="main-outlet"></router-outlet>
    </div>

  </div>
</div>